<template>
  <v-container class="rs-container">
    <v-form ref="subFormcontactReqTSA" lazy-validation class="mt-2">
      <v-row justify="center" class="h-100 flex-column" align="center">
        <v-col cols="12">
          <v-text-field
            color="#4caf50"
            v-model="username"
            readonly
            style="font-size: small !important;"
            label="ชื่อผู้ใช้ (Username)"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            color="#4caf50"
            v-model="email"
            :rules="email_Rules"
            style="font-size: small !important;"
            placeholder="e-mail (ที่สามารถติดต่อได้)"
            hint="Ex.(มากกว่า 2 e-mail) mail1@gmail.com,mail2@gmail.com"
            label="e-mail (ที่สามารถติดต่อได้)*"
            outlined
            dense
          ></v-text-field>
          <v-text-field
            color="#4caf50"
            v-model="tel"
            :rules="tel_Rules"
            style="font-size: small !important;"
            label="เบอร์โทร (ที่สามารถติดต่อได้)*"
            v-mask="'## #### ####'"
            placeholder="ระบุเบอร์โทร (ที่สามารถติดต่อได้)"
            outlined
            dense
          ></v-text-field>

          <v-text-field
            color="#4caf50"
            v-model="organization"
            label="หน่วยงาน/องค์กร*"
            placeholder="ระบุหน่วยงาน/องค์กร"
            style="font-size: small !important;"
            :rules="required"
            outlined
            dense
          ></v-text-field>
          <!-- <v-select
            :items="itemsTiltle"
            style="font-size: small !important;"
            v-model="title"
            label="เรื่อง*"
            :rules="required"
            dense
            outlined
          ></v-select> -->
          <!-- <v-file-input
            v-model="fileInput"
            color="#4caf50"
            counter
            dense
            label="อัพโหลดไฟล์"
            multiple
            prepend-icon=""
            append-icon="mdi-paperclip"
            outlined
            >
            <template v-slot:selection="{ text }">
              <v-chip
                small
                label
                color="#4caf50"
                class="text-white"
              >
                {{ text }}
              </v-chip>
            </template>
          </v-file-input> -->
          <v-textarea
            color="#4caf50"
            v-model="text"
            label="หมายเหตุ"
            style="font-size: small !important;"
            placeholder="ex. ตัวอย่างข้อมูลคร่าวๆ เกี่ยวกับเอกสารที่จะใช้ TSA , ต้องการเชื่อมต่อ แบบ API, เคยใช้บริการ TSA ของ ETDA มาก่อน"
            outlined
            rows="4"
            row-height="25"
            auto-grow
            dense
          ></v-textarea>
          <div class="d-flex justify-center">
            <v-btn color="green text-white" @click="validate()">ส่ง</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: 'requestService',
  data () {
    return {
      username: '',
      email: '',
      tel: '',
      title: '',
      text: '',
      organization: '',
      fileInput: null,
      email_Rules: [(v) => !!v || 'กรุณาใส่  email *', (v) => /.+@.+\..+/.test(v) || 'E-mail ไม่ถูกต้อง'],
      tel_Rules: [(v) => (v && v.length >= 1 && v.length <= 12) || 'โปรดกรอกหมายเลขให้ครบถ้วน'],
      required: [(v) => !!v || 'โปรดระบุ'],
      itemsTiltle: ['การยื่นแบบ', 'Dashboard', 'การตั้งค่า', 'การใช้งานอื่น ๆ'],
      mobile: window.innerWidth <= 959
    }
  },
  created () {
    addEventListener('resize', () => {
      this.mobile = innerWidth <= 959
    })
  },
  mounted () {
    this.username = localStorage.getItem('username')
  },
  methods: {
    validate () {
      const validateRes = this.$refs.subFormcontactReqTSA.validate()
      if (validateRes) {
        const dataSent = {
          username: this.username,
          email: this.email,
          phone: this.tel,
          title: this.organization,
          content: this.text
        }
        console.log('dataSent', dataSent)
        this.confirm(dataSent)
      }
    },
    confirm (data) {
      this.$swal({
        title: '<p style="font-family: Kanit">ยืนยันการส่งคำขอใช้บริการ TSA?</p>',
        icon: 'warning',
        showCancelButton: true,
        allowEscapeKey: false,
        allowEnterKey: false,
        allowOutsideClick: false,
        confirmButtonColor: 'green',
        cancelButtonColor: 'red',
        cancelButtonText: '<a style="font-family: Kanit">ยกเลิก</a>',
        confirmButtonText: '<a style="font-family: Kanit">ตกลง</a>'
      }).then((result) => {
        if (result.value) {
          this.submit(data)
        }
      })
    },
    async submit (data) {
      const res = await this.$store.dispatch('submitFormEnroll', data)
      if (res.responseCode === 200) {
        this.$swal({
          title: '<span style="font-family: prompt; font-size: large; font-weight: 500;">ส่งสำเร็จ</span>',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000
        })
        setTimeout(() => {
          this.resetData()
        }, 2000);
      } else {
        this.$swal({
          title: '<span style="font-family: prompt; font-size: large; font-weight: 500;">ส่งไม่สำเร็จ</span>',
          icon: 'error',
          showConfirmButton: false,
          timer: 2000
        })
      }
      // console.log(res)
    },
    resetData () {
      this.$refs.subFormcontactReqTSA.resetValidation()
      this.email = ''
      this.tel = ''
      this.title = ''
      this.text = ''
      this.organization = ''
    }
  }
}
</script>

<style scoped>
.h-100 {
  height: 100% !important;
}

.file-input {
  display: flex !important;
  /* padding-right: 20% !important; */
}
img.responsive {
  width: 100%;
  height: 100%;
}
.rs-container {
  max-width: 100% !important;
}
</style>
